import { matchConcessionaria } from '../data/concessionarias'
import { validarCpfCnpj, formatCpfCnpjDisplay } from './cpfCnpj'

function parseNumber(value) {
  if (value == null || value === '') return null
  if (typeof value === 'number') return Number.isFinite(value) ? value : null
  const cleaned = String(value)
    .replace(/[^\d,.-]/g, '')
    .replace(/\.(?=\d{3}(\D|$))/g, '')
    .replace(',', '.')
  const n = Number(cleaned)
  return Number.isFinite(n) ? n : null
}

function parseReferenceToYYYYMM(ref) {
  if (!ref) return ''
  const s = String(ref).trim().toUpperCase()
  const meses = {
    JAN: '01', FEV: '02', MAR: '03', ABR: '04', MAI: '05', JUN: '06',
    JUL: '07', AGO: '08', SET: '09', OUT: '10', NOV: '11', DEZ: '12',
  }
  let m = s.match(/^([A-Z]{3,})\D+(\d{4})$/)
  if (m) {
    const mes = meses[m[1].slice(0, 3)]
    if (mes) return `${m[2]}-${mes}`
  }
  m = s.match(/^(\d{1,2})\D+(\d{4})$/)
  if (m) return `${m[2]}-${String(m[1]).padStart(2, '0')}`
  m = s.match(/^(\d{4})-(\d{1,2})$/)
  if (m) return `${m[1]}-${String(m[2]).padStart(2, '0')}`
  return ''
}

/**
 * Recebe o JSON extraído pelo OpenAI e o form atual (reativo do Wizard)
 * e mescla os campos extraídos no form, aplicando guardas contra erros comuns.
 *
 * Retorna metadados úteis para a UI (concessionária não identificada, etc.).
 */
export function mapearJsonParaForm(json, form) {
  const meta = { concessionariaNaoIdentificada: '' }
  if (!json) return meta

  if (json.customer_name) form.nome = String(json.customer_name).trim()

  if (json.cpf_cnpj) {
    let doc = String(json.cpf_cnpj).replace(/\D/g, '')
    if (doc.length === 13 && validarCpfCnpj('0' + doc)) doc = '0' + doc
    if (doc.length === 10 && validarCpfCnpj('0' + doc)) doc = '0' + doc
    if (doc && validarCpfCnpj(doc)) {
      // Grava com máscara; os dígitos servem só à validação/detecção de tipo
      form.person_number = formatCpfCnpjDisplay(doc)
      if (doc.length === 14) form.person_type = 'pj'
      else if (doc.length === 11) form.person_type = 'pf'
    }
  }

  let companyMatchFound = false
  if (json.company_name) {
    const m = matchConcessionaria(json.company_name)
    if (m) {
      form.concessionaria_id = m.id
      companyMatchFound = true
    } else {
      meta.concessionariaNaoIdentificada = String(json.company_name).trim()
    }
  }

  //if (json.account_number) form.numero_instalacao = String(json.account_number)

  const history = Array.isArray(json?.consumption?.history) ? json.consumption.history : []
  const historyNums = history
    .map(h => parseNumber(h?.consumed_kwh))
    .filter(n => n != null)
  let avg = null
  if (historyNums.length > 0) {
    avg = historyNums.reduce((a, b) => a + b, 0) / historyNums.length
  } else {
    avg = parseNumber(json?.consumption?.consumed_kwh)
  }
  if (avg != null) form.kwh_avg = String(Math.round(avg))

  const refYM = parseReferenceToYYYYMM(json?.billing_period?.reference)
  if (refYM) form.mes_referencia = refYM

  const totalNum = parseNumber(json?.total_due)
  if (totalNum != null) form.valor_fatura = String(totalNum)

  const faseMap = { monofasico: 'monofasico', bifasico: 'bifasico', trifasico: 'trifasico' }
  const faseRaw = json?.installation?.supply_phase
  if (faseRaw && faseMap[faseRaw]) form.tipo_fase = faseMap[faseRaw]

  const addr = json.address || {}
  if (addr.zip_code) {
    // Grava com máscara (#####-###); ViaCEP tira a máscara só na consulta
    const cepDigits = String(addr.zip_code).replace(/\D/g, '').slice(0, 8)
    form.cep = cepDigits.length === 8 ? cepDigits.replace(/(\d{5})(\d{3})/, '$1-$2') : cepDigits
  }
  if (addr.street)       form.logradouro = addr.street
  if (addr.number)       form.numero = /\d/.test(String(addr.number)) ? String(addr.number) : 'S/N'
  if (addr.complement)   form.complemento = addr.complement
  if (addr.neighborhood) form.bairro = addr.neighborhood
  if (addr.city)         form.cidade = addr.city
  if (addr.state)        form.estado = String(addr.state).toUpperCase().slice(0, 2)

  // Guarda 1: nome igual ao endereço — provável erro de extração
  if (form.nome) {
    const nome       = form.nome.trim().toUpperCase()
    const cidade     = (addr.city || '').trim().toUpperCase()
    const bairro     = (addr.neighborhood || '').trim().toUpperCase()
    const logradouro = (addr.street || '').trim().toUpperCase()
    const nomeEhEndereco =
      nome === cidade ||
      nome === bairro ||
      (logradouro !== '' && logradouro.startsWith(nome)) ||
      (logradouro !== '' && nome === logradouro)
    if (nomeEhEndereco) form.nome = ''
  }

  // Guarda 2: nome bate com concessionária conhecida
  if (form.nome && matchConcessionaria(form.nome)) {
    form.nome = ''
  }

  // Fallback: usar company_name como nome se não foi identificada como concessionária
  if (!form.nome && !companyMatchFound && json.company_name) {
    form.nome = String(json.company_name).trim()
  }

  return meta
}
